import { connect } from 'react-redux';
import { getTranslation } from "../../../reducers/common/localization";
import { fetchGetLevels, getLevelsData } from './../../../reducers/common/levels';
import { fetchGetTitleLangs, getOptionalTitleLangsData } from '../../../reducers/common/titleLangs';
import BulkFileFormatDetails from "./BulkFileFormatDetails";

const mapStateToProps = state => {
    return {
        levels: getLevelsData(state),
        langs: getOptionalTitleLangsData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetLevels());
            dispatch(fetchGetTitleLangs());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkFileFormatDetails);



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkFileFormatDetails/BulkFileFormatDetails.container.js